<template>
	<div class="icp" v-if="!configStore.electronMode">
		<div class="icp-content">
			<div class="icp-record">
				<img class="icp-icon" src="../../assets/image/icp_logo.png" alt="备案图标">
				<a target="_blank" rel="noopener noreferrer" href="https://beian.miit.gov.cn/">{{ icpNo }}</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		icpNo() {
			return process.env.VUE_APP_ICP_NO;
		}
	}
}
</script>

<style lang="scss">
.icp {
	position: fixed;
	bottom: 16px;
	left: 0;
	display: flex;
	justify-content: center;
	width: 100%;
	z-index: 2;

	.icp-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 6px;
		padding: 0 12px;
		text-align: center;
	}

	.icp-record {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		line-height: 1;
	}

	.icp-icon {
		width: 14px;
		height: 14px;
		opacity: 0.85;
	}

	a {
		font-size: 13px;
		font-weight: 400;
		line-height: 1;
		color: #64748b;
		text-decoration: none;
		transition: color 0.2s ease;
	}

	a:hover {
		color: #2563eb;
	}

	@media (max-width: 768px) {
		bottom: 12px;

		a {
			font-size: 12px;
		}
	}
}
</style>
